// CommentsAddButton.jsx

import React from 'react';

// Context
import { useTheme } from 'context/ThemeContext';

// CSS
import './CommentsAddButton.css';

// Components
import Button from 'components/button/Button';

/**
 * CommentsAddButton component
 *
 * Renders buttons for adding comments and toggling emoji selector.
 *
 * @param {object} onClick - The function to call when the send button is clicked.
 * @param {object} onEmojiClick - The function to call when the emoji button is clicked.
 *
 * @returns {ReactNode} The rendered component.
 */
const CommentsAddButton = ({ onClick, onEmojiClick }) => {

    // ----- CONTEXT ----- //

    // Theme Context

    const { theme } = useTheme();

    // ----- RENDER ----- //

    return (
        <div className="comments-add-button-container">

            <Button
              iconKey="sentiment_satisfied"
              iconColor={theme.foregroundMuted}
              iconSize={20}
              padding="8px"
              onClick={onEmojiClick}
            />

            <Button
              iconKey="send"
              iconColor={theme.foregroundMuted}
              label="Send"
              onClick={onClick}
            />

        </div>
    );
};

// Dev Tools
CommentsAddButton.displayName = 'CommentsAddButton';

export default CommentsAddButton;
